export const ApplicationConstant = {
    ApplicationID : 5,
    clientId : 4,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    SERVICE_USER_APP_ID : 4
};
